import { InboxOutlined, RedoOutlined } from '@ant-design/icons';
import { Col, Empty, Row, Spin, Tooltip } from 'antd';
import { getListProject } from 'api/project/partnerAdmin.api';
import ErrorImage from 'assets/images/errorImage.jpg';
import Breadcrumb from 'components/Layout/ApplicationLayout/Breadcrumb';
import HeaderListDataLayout from 'components/Layout/HeaderListDataLayout';
import LayoutDefault from 'components/Layout/LayoutDefault';
import Pagination from 'components/Pagination';
import {
  defaultPageSizeOptions,
  defaultSelectPageSizeOption,
} from 'constant/Pagination/pageSizeOption';
import UseCustomQuery from 'hook/useQuery/useCustomQuery';
import useSearchKeyword from 'hook/useSearchKeyword';
import useSetTitlePage from 'hook/useSetTitlePage';
import useMultiLanguageCompanyList from 'page/Application/ManageCompanyList/CompanyList/hook/useMultiLanguageCompanyList';
import Thumbnail from 'page/Application/ProjectRegistration/component/Thumbnail';
import {
  DescProject,
  ProjectItem,
  TitleProject,
} from 'page/Application/ProjectRegistration/ProjectRegistrationOverview/styled';
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { network } from 'recoil/atom/network';
import { ButtonTextIcon, LineVertical } from 'components/Button';

const ProjectRegistrationOverview = () => {
  useSetTitlePage('案件登録お申込み | Soliton パートナーサイト', true);
  const navigate = useNavigate();
  const { searchKeyword, setSearchKeyword, onSearch, emptyText } =
    useSearchKeyword();
  const { useQueryAPI } = UseCustomQuery();
  const [page, setPage] = useState(10);
  const [current, setCurrent] = useState(1);
  const [searchValue, setSearchValue] = useState('');

  const location = useLocation();
  const { searchKeywordState } = location.state || {};
  const { COMPANY_LIST_NO_DATA } = useMultiLanguageCompanyList();
  const isOnline = useRecoilValue(network);

  const { data: projectData = [], isLoading } = useQueryAPI({
    api: getListProject,
    key: 'listProject',
    params: {
      pageNumber: current,
      pageSize: page,
      keyword: encodeURIComponent(searchKeyword) ?? searchKeyword,
      sortField: '',
      sortDirection: '',
    },
  });

  const listItem = useMemo(() => {
    return [
      {
        title: <Link to={'/'}>パートナー専用ページ</Link>,
      },
      {
        title: '案件登録お申込み',
      },
    ];
  }, []);

  const handleChangePageSize = (value) => {
    if (isOnline) {
      setPage(value);
      setCurrent(1);
    }
  };

  const handleResetData = () => {
    setPage(10);
    setCurrent(1);
    setSearchValue('');
    setSearchKeyword('');
  };

  const handlePagingChange = (pageNumber, pageSize) => {
    if (isOnline) {
      setCurrent(pageNumber);
      setPage(pageSize);
    }
  };

  const projectList = useMemo(() => {
    if (projectData && projectData.ec === false) {
      return projectData.data.list;
    } else return [];
  }, [projectData]);

  const handleMoveToDetail = (id) => {
    if (isOnline)
      navigate(`detail/${id}`, {
        state: {
          searchKeywordState: searchKeyword,
        },
      });
  };

  useEffect(() => {
    if (searchKeyword) {
      setCurrent(1);
    }
  }, [searchKeyword]);

  useEffect(() => {
    setSearchKeyword(searchKeywordState ?? '');
    setSearchValue(searchKeywordState ?? '');
    const updatedState = {
      searchKeywordState: '',
    };
    navigate(location.pathname, { state: updatedState, replace: true });
  }, []);

  return (
    <>
      <Breadcrumb listItem={listItem} titlePage={'案件登録お申込み'} />
      <LayoutDefault>
        <Suspense fallback={isLoading}>
          <Spin spinning={isLoading} style={{ maxHeight: 'unset' }}>
            <HeaderListDataLayout
              titleScreen={'案件登録お申し込み一覧'}
              searchPlaceholder={'タイトル、を検索します。'}
              isLoading={isLoading}
              onSearch={onSearch}
              value={page}
              handleChangePageSize={handleChangePageSize}
              pageSizeOptions={defaultSelectPageSizeOption}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
            >
              {' '}
              <ButtonTextIcon
                text={'リフレッシュ'}
                icon={<RedoOutlined />}
                onClick={handleResetData}
              />
              <LineVertical />
            </HeaderListDataLayout>
            <>
              {isLoading && <div style={{ height: 520 }} />}
              {(projectList === null || projectList?.length === 0) &&
                isLoading === false && (
                  <Empty
                    image={<InboxOutlined />}
                    imageStyle={{ fontSize: 80 }}
                    description={null}
                    style={{ fontSize: '16px', minHeight: 532 }}
                  >
                    {emptyText || COMPANY_LIST_NO_DATA}
                  </Empty>
                )}
              {projectList?.length > 0 && isLoading === false && (
                <Row gutter={20}>
                  {projectList?.map((item) => (
                    <Col
                      xs={24}
                      sm={12}
                      md={12}
                      lg={8}
                      xl={6}
                      key={item.projectId}
                    >
                      <ProjectItem>
                        <div onClick={() => handleMoveToDetail(item.projectId)}>
                          {item.image === '' ? (
                            <Thumbnail imageUrl={ErrorImage} />
                          ) : (
                            <Thumbnail imageUrl={item.image} />
                          )}
                        </div>
                        <DescProject>
                          <TitleProject
                            onClick={() => handleMoveToDetail(item.projectId)}
                          >
                            <Tooltip
                              title={item.projectName}
                              placement={'topLeft'}
                            >
                              {item.projectName}
                            </Tooltip>
                          </TitleProject>
                        </DescProject>
                      </ProjectItem>
                    </Col>
                  ))}
                </Row>
              )}
            </>
            <Pagination
              totalTitle={'案件登録お申込み'}
              total={projectData.data?.total}
              currentPage={current}
              pageSize={page}
              pageSizeOptions={defaultPageSizeOptions}
              handlePagingChange={handlePagingChange}
              handleChangePageSize={handleChangePageSize}
            />
          </Spin>
        </Suspense>
      </LayoutDefault>
    </>
  );
};

export default ProjectRegistrationOverview;
